export default "__VITE_ASSET__Ce56QJwi__"